import React, { useState, useEffect } from "react";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";

import { OPContainer, OPWrapper } from "../settings/SettingsStyled";
import { Box, Button, BackBtn, Header, BtnGroup, Btn } from "./SetBetStyled";
import useBetOperations from "../../bets";
export default ({
  handleAbove,
  bet,
  handleNotification,
  handleBetAmount,
  aboveAnim,
  handleAboveAnimation,
  userInfo,
  userSettings,
  audio,
}) => {
  const { minBet, maxBet, curr, precision } = userInfo;
  const [value, setvalue] = useState(bet);
  const [inputValue, setinputValue] = useState(value);

  const [divideAnim, setdivideAnim] = useState(false);
  const [doubleXanim, setdoubleXanim] = useState(false);
  const [fiveXanim, setfiveXanim] = useState(false);
  const [plusPressAnim, setplusPressAnim] = useState(false);
  const [minusPressAnim, setminusPressAnim] = useState(false);
  const [setBtnAnim, setsetBtnAnim] = useState(false);
  const [backBtnAnim, setbackBtnAnim] = useState(false);

  const [soundPlayed, setSoundPlayed] = useState(false);
  const { confirm, goBack } = audio;

  const [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ] = useBetOperations(
    value,
    userSettings.volume,
    userSettings.sound,
    handleNotification,
    minBet,
    maxBet,
    curr,
    precision
  );

  useEffect(() => {
    setvalue(useBet);
    setinputValue(useBet);
  }, [useBet]);

  const handleChange = (e) => {
    const onlyNumbersAndDot = /^\d*\.?\d*$/;
    const n = e.target.value;
    if (onlyNumbersAndDot.test(n)) {
      if (n.indexOf(".") !== -1) {
        if (n.length - n.indexOf(".") < precision + 2) {
          setinputValue(n);
          handleNotification(false);
        }
      } else {
        setinputValue(n);
      }
    }
  };

  const handleBlur = (e) => {
    const n = e.target.value;
    const max = maxBet;
    const min = minBet;

    if (n < min || n === "" || n === ".") {
      setinputValue(min.toFixed(precision));
      setvalue(min.toFixed(precision));
      handleNotification(
        `Minimum stake limit is ${minBet.toFixed(precision)} ${curr}`
      );
    } else if (n > max) {
      setinputValue(max.toFixed(precision));
      setvalue(max.toFixed(precision));
      handleNotification(
        `Maximum stake limit is ${maxBet.toFixed(precision)} ${curr}`
      );
    } else if (n.startsWith(".")) {
      setinputValue(0 + n); ///  es ar momwons
      setvalue(0 + n);
    }

    else {
      setinputValue(n);
      setvalue(n);
      handleNotification(false);
    }
  };

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  return (
    <OPContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <Box aboveAnim={aboveAnim}>
          <Header>
            <p>{curr}</p>
            <div>
              <input
                type="text"
                maxLength="10"
                value={inputValue}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <span />
            </div>
          </Header>
          <div style={{ marginTop: "20%" }}>
            <BtnGroup soundPlayed={soundPlayed}>
              <Btn
                divide={divideAnim}
                onClick={() => {
                  clearTimeout();
                  setAnimation(divideAnim, setdivideAnim);
                  divide();
                }}
              >
                1/2
              </Btn>
              <Btn
                double={doubleXanim}
                onClick={() => {
                  clearTimeout();
                  setAnimation(doubleXanim, setdoubleXanim);
                  multiply(2);
                }}
              >
                2x
              </Btn>
              <Btn
                fiveX={fiveXanim}
                onClick={() => {
                  clearTimeout();
                  setAnimation(fiveXanim, setfiveXanim);
                  multiply(5);
                }}
              >
                5x
              </Btn>
              <Btn
                minusPress={minusPressAnim}
                onClick={() => {
                  minus();
                }}
                onTouchStart={() => {
                  setminusPressAnim(true);
                  handleButtonPress("acceleratableMinus");
                }}
                onTouchEnd={() => {
                  setminusPressAnim(false);
                  handleButtonRelease();
                }}
                onMouseDown={() => {
                  setminusPressAnim(true);
                  handleButtonPress("acceleratableMinus");
                }}
                onMouseUp={() => {
                  setminusPressAnim(false);
                  handleButtonRelease();
                }}
                onMouseLeave={() => {
                  setminusPressAnim(false);
                  handleButtonRelease();
                }}
              >
                <MinusSVG />
              </Btn>
              <Btn
                plusPress={plusPressAnim}
                onClick={() => {
                  plus();
                }}
                onTouchStart={() => {
                  setplusPressAnim(true);
                  handleButtonPress("acceleratablePlus");
                }}
                onTouchEnd={() => {
                  setplusPressAnim(false);
                  handleButtonRelease();
                }}
                onMouseDown={() => {
                  setplusPressAnim(true);
                  handleButtonPress("acceleratablePlus");
                }}
                onMouseUp={() => {
                  setplusPressAnim(false);
                  handleButtonRelease();
                }}
                onMouseLeave={() => {
                  setplusPressAnim(false);
                  handleButtonRelease();
                }}
              >
                <PlusSVG />
              </Btn>
            </BtnGroup>
            <Button
              set={setBtnAnim}
              soundPlayed={soundPlayed}
              onClick={() => {
                clearTimeout();
                setAnimation(setBtnAnim, setsetBtnAnim);
                handleBetAmount(useBet);
                confirm();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnimation(false);
                  setTimeout(() => {
                    handleAbove(false);
                    setSoundPlayed(true);
                  }, 150);
                }, 100);
              }}
            >
              set
            </Button>
            <BackBtn
              soundPlayed={soundPlayed}
              backBtn={backBtnAnim}
              onClick={() => {
                clearTimeout();
                setSoundPlayed(true);
                setAnimation(backBtnAnim, setbackBtnAnim);
                setTimeout(() => {
                  goBack();
                  handleAboveAnimation(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 150);
                }, 100);
              }}
            >
              Back
            </BackBtn>
          </div>
        </Box>
      </OPWrapper>
    </OPContainer>
  );
};
